import * as React from "react";
import type { HeadFC, PageProps } from "gatsby";
import Hero from "../components/hero";
import AboutUs from "../components/about-us";
import PaymentOptions from "../components/payment-options";
import Layout from "../components/layout";

const IndexPage: React.FC<PageProps> = () => {
  return (
    <Layout>
      <Hero />
      <AboutUs />
      <PaymentOptions />
    </Layout>
  );
};

export default IndexPage;

export const Head: HeadFC = () => (
  <title>Spectrum Acceptance | Affordable Auto Financing</title>
);
